"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroblockToJSON = exports.MicroblockFromJSONTyped = exports.MicroblockFromJSON = void 0;
function MicroblockFromJSON(json) {
    return MicroblockFromJSONTyped(json, false);
}
exports.MicroblockFromJSON = MicroblockFromJSON;
function MicroblockFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canonical': json['canonical'],
        'microblock_canonical': json['microblock_canonical'],
        'microblock_hash': json['microblock_hash'],
        'microblock_sequence': json['microblock_sequence'],
        'microblock_parent_hash': json['microblock_parent_hash'],
        'block_height': json['block_height'],
        'parent_block_height': json['parent_block_height'],
        'parent_block_hash': json['parent_block_hash'],
        'parent_burn_block_hash': json['parent_burn_block_hash'],
        'parent_burn_block_time': json['parent_burn_block_time'],
        'parent_burn_block_time_iso': json['parent_burn_block_time_iso'],
        'parent_burn_block_height': json['parent_burn_block_height'],
        'block_hash': json['block_hash'],
        'txs': json['txs'],
    };
}
exports.MicroblockFromJSONTyped = MicroblockFromJSONTyped;
function MicroblockToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'canonical': value.canonical,
        'microblock_canonical': value.microblock_canonical,
        'microblock_hash': value.microblock_hash,
        'microblock_sequence': value.microblock_sequence,
        'microblock_parent_hash': value.microblock_parent_hash,
        'block_height': value.block_height,
        'parent_block_height': value.parent_block_height,
        'parent_block_hash': value.parent_block_hash,
        'parent_burn_block_hash': value.parent_burn_block_hash,
        'parent_burn_block_time': value.parent_burn_block_time,
        'parent_burn_block_time_iso': value.parent_burn_block_time_iso,
        'parent_burn_block_height': value.parent_burn_block_height,
        'block_hash': value.block_hash,
        'txs': value.txs,
    };
}
exports.MicroblockToJSON = MicroblockToJSON;
//# sourceMappingURL=Microblock.js.map